import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '精选专题', href: '#index' },
  { label: '热播榜单', href: '#ranking' },
  { label: '重磅推荐', href: '#carousel' },
  { label: '观众热评', href: '#comments' },
  { label: '最新动态', href: '#updates' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="font-heading text-xl md:text-2xl font-bold text-primary-500 whitespace-nowrap">
            桃子影院
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}